import {  QUERY_GET_DOCUMENTATION_TEMPLATES, QUERY_GET_LETTER_TYPES} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getDocumentationTemplate = baseThunk("documentationTemplates/getDocumentationTemplatesList", QUERY_GET_DOCUMENTATION_TEMPLATES, "GET")
export const getLetterTypes = baseThunk("letterTypes/getLetterTypes", QUERY_GET_LETTER_TYPES, "GET")
